import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

interface RedirectToV2Props {
  to: string;
}

const RedirectToV2: React.FC<RedirectToV2Props> = ({ to }) => {
  const params = useParams<Record<string, string>>();
  const location = useLocation();

  React.useEffect(() => {
    const baseUrl = (process.env.REACT_APP_V2_BASE_URL ?? '').replace(
      /\/$/,
      '',
    );
    let resolvedPath = to;
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        resolvedPath = resolvedPath.replace(
          `:${key}`,
          encodeURIComponent(value),
        );
      }
    });
    const target = `${baseUrl}${resolvedPath}${location.search ?? ''}${
      location.hash ?? ''
    }`;
    window.location.replace(target);
  }, [to, params, location.search, location.hash]);

  return null;
};

export default RedirectToV2;
